import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { isSameDay } from 'date-fns';

import { type ValueWithUnitOfMeasure } from '@blaze-shared/shared-util';

import { Calendar, CalendarEvent, CalendarTimeFormat, EventChangeEvent } from '../calendar.models';

@Component({
  selector: 'blaze-calendar-week-view',
  templateUrl: './calendar-week-view.component.html',
  styleUrls: ['./calendar-week-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalendarWeekViewComponent {
  add = output<Partial<CalendarEvent>>();
  delete = output<CalendarEvent>();
  details = output<CalendarEvent>();
  edit = output<CalendarEvent>();
  eventChange = output<EventChangeEvent>();
  eventDrop = output<CdkDragDrop<any, any, CalendarEvent>>();
  headerClick = output<Date>();

  @Input() availableHours: { min: number; max: number } = { min: 0, max: 24 };
  @Input() calendars: Calendar[] = [];
  @Input() dates: Date[] = [];
  @Input() dayViewColumnWidth: string | undefined;
  @Input() defaultDurationMinutes = 60;
  @Input() eventFontSize: ValueWithUnitOfMeasure = '13px';
  @Input() headerHeightPx = 0;
  @Input() isAddEnabled = false;
  @Input() isDeleteEnabled = false;
  @Input() isDetailsViewEnabled = false;
  @Input() isEditEnabled = false;
  @Input() isEventDragDisabled = false;
  @Input() isUsingOldPaddingStrategy = false;
  @Input() selectedDate: Date = new Date();
  @Input() timeFormat: CalendarTimeFormat = CalendarTimeFormat['12H'];
  @Input() timeScale = 1;
  @Input() timeZone: string | null = null;

  today = new Date();

  extractEventsFromCalendars(date: Date): CalendarEvent[] {
    const events: CalendarEvent[] = [];

    for (const calendar of this.calendars) {
      events.push(
        ...(calendar.events[date.getFullYear()]?.[date.getMonth()]?.[date.getDate()] ?? []),
      );
    }

    return events;
  }

  isSelected(date: Date): boolean {
    return isSameDay(this.selectedDate, date);
  }

  isToday(date: Date): boolean {
    return isSameDay(new Date(), date);
  }

  onSwitchToDayView(day: Date): void {
    this.headerClick.emit(day);
  }
}
